import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { CurrencyPipe } from '../currency.pipe';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  inputs: ['type', 'value', 'field', 'placeholder', 'center', 'format', 'autosave']
})
export class EditComponent implements OnInit, AfterViewChecked {
    private saving: boolean = false;
    private field: string;
    private type: string;
    private value: string = '';
    private placeholder: string = '';
    private center: boolean = false;
    private format: string = '';
    private autosave: boolean = true;

    @ViewChild('textarea') theTextarea: ElementRef;

    public constructor(private http: Http, private route: ActivatedRoute) {}

    public ngAfterViewChecked() {
        if(this.center === true) {
            let element = this.theTextarea.nativeElement;
            let height = element.clientHeight;
            if(height >= 38)
                element.style.marginTop = '2px';
            else
                element.style.marginTop = '11px';
        }
    }

    public ngOnInit() {
        if(typeof this.value === 'undefined' || this.value === 'null' || this.value === null) {
            this.setText('%' + this.placeholder + '%');
        }
    }

    private setText(value: string): void {
        if(this.format === 'currency')
            this.value = new CurrencyPipe().transform(value);
        else
            this.value = value;
    }
    private saveData(value: string): void {
        if(this.autosave === false) return;
        if(value === '') {
            this.value = '%' + this.placeholder + '%';
        }
        this.saving = true;
        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.post(environment.endpoint+'/update/' + this.route.snapshot.params['id'], {key: this.field, value: value}, {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status != 'OK')
                        alert(res.results);
                    this.saving = false;
                },
                err => { console.log(err); this.saving = false; }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/edit/edit.component.ts